"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _device_salesorder = require("@/api/device_salesorder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      typeOptions: [{
        value: 'qudao',
        label: '渠道报表'
      }, {
        value: 'sales',
        label: '销售员报表'
      }],
      date: '',
      dateTYpe: {
        'start_date': '',
        'end_date': ''
      },
      listLoading: true,
      tableData: {
        results: []
      },
      listQuery: {
        page: 1
      },
      attrOptions: [{
        value: 1,
        label: '购买'
      }, {
        value: 2,
        label: '赠送'
      }, {
        value: 3,
        label: '试用机'
      }, {
        value: 4,
        label: '其它'
      }]
    };
  },
  created: function created() {
    // this.getList()
  },
  methods: {
    checkPermission: _permission.default,
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.listLoading = true;
              // const res = await getDeviceReportList()
              // console.log(res.data.count)
              // this.listQuery.page_size = res.data.count
              (0, _device_salesorder.getDeviceReportList)(this.listQuery).then(function (response) {
                if (response.data) {
                  console.log(response.data.count);
                  _this.tableData.results = response.data.results;
                  console.log(_this.tableData);
                }
                _this.listLoading = false;
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    clearData: function clearData() {
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      if (this.listQuery.start_date === '' || this.listQuery.start_date === undefined || this.listQuery.start_date === null) {
        this.$message({
          type: 'error',
          message: '请先选择开始及结束查询时间!'
        });
      } else if (this.listQuery.category === '' || this.listQuery.category === undefined || this.listQuery.category === null) {
        this.$message({
          type: 'error',
          message: '请先选择报表类型!'
        });
      } else {
        this.getList();
      }
    },
    getDate: function getDate() {
      if (this.date != null) {
        this.listQuery.start_date = this.date[0];
        this.listQuery.end_date = this.date[1];
      } else {
        this.listQuery.start_date = '';
        this.listQuery.end_date = '';
      }
      // this.handleFilter()
    }
  }
};